module.exports = __webpack_public_path__ + "static/media/sector3.4f164443.svg";